import { setOptions, importLibrary } from '@googlemaps/js-api-loader'

// Carga singleton de Google Maps JS API con la API funcional (v2): setOptions +
// importLibrary. La clase Loader quedó deprecada. La API key viene de .env.local
// (VUE_APP_GOOGLE_MAPS_KEY) — NO se hardcodea.
let libs = null

// loadGoogleMaps carga las librerías una sola vez y devuelve { maps, marker, core }.
// - maps:   Map, InfoWindow, Polyline…
// - marker: AdvancedMarkerElement, PinElement…
// - core:   LatLngBounds, event… (viven en 'core', no en 'maps')
export async function loadGoogleMaps() {
  if (libs) return libs

  setOptions({
    apiKey: process.env.VUE_APP_GOOGLE_MAPS_KEY,
    version: 'weekly'
  })

  const [maps, marker, core] = await Promise.all([
    importLibrary('maps'),
    importLibrary('marker'),
    importLibrary('core')
  ])

  libs = { maps, marker, core }
  return libs
}

// Map ID con el estilo dark configurado en Google Cloud (requerido por
// AdvancedMarkerElement). Público por diseño.
export const MAP_ID = '53c9374e7fc05763e8ce0bd2'
